module.exports = __webpack_public_path__ + "img/Logo-33.b1de114d.svg";